import { FormDataTypes } from "../../../types/FormDataTypes";
import { useForm } from "../../../provider/Form/FormProvider";
import Grid from "@mui/material/Grid";
import { translate } from "../../../services/translations/translations";
import { requiredValidator } from "../../../services/validationRules";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import Group from "../../Wizard/Group";
import Address from "../Common/Address/Address";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import React, { useEffect } from "react";

const RentalContractPropertyAddress = () => {
  const { values, handleChange }: FormDataTypes = useForm();

  useEffect(() => {
    if (values.contractAddressIsCurrentAddress !== "yes") {
      return;
    }

    let addressToCopyFrom = null;
    switch (values.contractPartyType) {
      case "tenant":
        addressToCopyFrom = values.customer.person.residenceAddress;
        break;
      case "landlord":
        addressToCopyFrom =
          values.opposingPartyType === "opposingPartyLegalEntity"
            ? values.opposingPartyLegalEntity.organization.address
            : values.opposingPartyPerson.residenceAddress;
        break;
      default:
        break;
    }

    handleChange({
      target: {
        name: "propertyAddress",
        value: addressToCopyFrom,
        type: "text"
      }
    });
  }, [values.contractAddressIsCurrentAddress]);

  return (
    <>
      <Grid
        container
        sx={{
          justifyContent: "flex-start",
          alignItems: "baseline"
        }}>
        <Grid size={12}>
          <Group
            type="radio"
            name={"contractAddressIsCurrentAddress"}
            question={translate("rentalContract.contractAddressIsCurrentAddress.question", values)}
            options={[
              {
                labelText: translate("rentalContract.contractAddressIsCurrentAddress.options.yes.label", values),
                labelIcon: <CheckIcon />,
                labelIconActive: <CheckIcon active />,
                value: "yes"
              },
              {
                labelText: translate("rentalContract.contractAddressIsCurrentAddress.options.no.label", values),
                labelIcon: <CrossIcon />,
                labelIconActive: <CrossIcon active />,
                value: "no"
              }
            ]}
            validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
          />
        </Grid>
        <Address path={"propertyAddress"}
                 headline={"Wie lautet die Anschrift der Wohnung, um die es in dem betroffenen Mietvertrag geht?"} />
        <Grid size={12}>
          <ValidatorTextField
            name={"propertyAddress.addressAddition"}
            label={translate("address.addressAddition.label", values)}
            helperText={translate("rentalContract.propertyAddress.helperText", values)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default RentalContractPropertyAddress;
